import { useState, useEffect, useContext } from 'react'
import { COOKIES, VEHICLE_TYPE } from '@/utils/constants'
import { getCookie, checkStringifiedJSON } from '@/utils/utils'
import { CookieNoticeStateContext } from '@/store/context/cookie-notice-context'
import { cookieCategoryIsActive } from '@/modern/utils/cookies'

const useLastSearchUrl = (vehicleType = 'car') => {
  const normalizedVehicleType = vehicleType.toLowerCase()
  const initialURL = `/${VEHICLE_TYPE[normalizedVehicleType]}/estoque`
  const [urlLastSearch, setUrlLastSearch] = useState(initialURL)
  const { cookies } = useContext(CookieNoticeStateContext)

  useEffect(() => {
    const { FILTER_SEARCH } = COOKIES
    if (!cookieCategoryIsActive(cookies, FILTER_SEARCH)) return

    const lastSearchesCookie = getCookie(FILTER_SEARCH)
    if (!lastSearchesCookie || !checkStringifiedJSON(lastSearchesCookie)) return

    try {
      const lastSearches = JSON.parse(lastSearchesCookie)
      const lastSearchUrl = lastSearches[normalizedVehicleType]
      if (lastSearchUrl) {
        setUrlLastSearch(lastSearchUrl)
      }
    } catch (error) {
      console.error('Failed to parse last searches cookie', error)
    }
  }, [cookies, normalizedVehicleType, vehicleType])

  return urlLastSearch
}

export default useLastSearchUrl
